$(document).ready(function () {

    // Filter posts by category via AJAX
    $('.js-blog-category').on('click', function () {
        var category = $(this).attr('data_slug');

        $('.js-blog-category').removeClass('active');
        $(this).addClass('active');
        
        // Load posts for the selected filtered category using the AJAX utility function.
        load_posts_ajax($('.js-load-more-articles'), {
            action: 'filter_blog_posts',
            category: category
        }, "replace");
    });

    $('.blog__buttons').on('click', '.js-load-more-articles', function () {
        // Get the active category slug
        const category = $('.js-blog-category.active').attr('data_slug') || '';
        
        // Load more posts for the selected filtered category using the AJAX utility function.
        load_posts_ajax($(this), {
            action: 'load_more_posts',
            category: category
        }, "append");
    });

});
